import { useQuery } from 'react-query'
import React, { Component } from "react";
import styled from "styled-components";
import { fetchUpgradesExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

async function fetch() {
    const { data } = await fetchUpgradesExplorer('bySource')
    return data.result;
}
function UpgradesBySource() {
    const { data, error, isError, isLoading } = useQuery('upgradesBySource', fetch)
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer  {...dataProps } />
}

export default UpgradesBySource